import { render, staticRenderFns } from "./OrganizationQuestionPurchased.vue?vue&type=template&id=47cacda6&scoped=true&"
import script from "./OrganizationQuestionPurchased.vue?vue&type=script&scoped=true&lang=js&"
export * from "./OrganizationQuestionPurchased.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./OrganizationQuestionPurchased.vue?vue&type=style&index=0&id=47cacda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cacda6",
  null
  
)

export default component.exports